import http from '../services/http';

let sysConfig = null;

export default {
  /**
   * 获取系统配置
   */
  sysConfigGet() {
    return new Promise((resolve, reject) => {
      if (sysConfig) {
        resolve(sysConfig);
      } else {
        http
          .post('h5/sys_config_get')
          .then((data) => {
            if (data.body && data.body.ret === 0 && data.body.body) {
              // 缓存到文件内
              sysConfig = data.body.body;
              resolve(data.body.body);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      }
    });
  },
};
